import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { pathgen } from 'object-path-generator';
import { Column, Typography } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import SignedAgreementAnimationWrapper from '../SignedAgreementAnimationWrapper/SignedAgreementAnimationWrapper';
import styles from './RelationshipSignedWithAnimations.module.scss';
export const RelationshipApprovedWithAnimationsDataTestIds = pathgen('RelationshipApprovedWithAnimationsDataTestIds');
const RelationshipApprovedWithAnimations = ()=>{
    const { t: clientFlowTexts } = useLocaleKeys('clientFlow');
    return /*#__PURE__*/ _jsx(SignedAgreementAnimationWrapper, {
        testId: RelationshipApprovedWithAnimationsDataTestIds.Root(),
        children: /*#__PURE__*/ _jsx(Column, {
            className: styles.thankYouSectionWrapper,
            children: /*#__PURE__*/ _jsxs(Column, {
                className: styles.thankYouSection,
                testId: RelationshipApprovedWithAnimationsDataTestIds.ThankYouSection(),
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "h3",
                        weight: "normal",
                        children: clientFlowTexts.relationshipSigned.thanksForSigning()
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "h6",
                        children: clientFlowTexts.confirmationEmailShortlyMessage()
                    })
                ]
            })
        })
    });
};
export default RelationshipApprovedWithAnimations;
